export const exemptionTypes={
    medFluVax: "medFluVax",
    medCovidVax: "medCovidVax",
    medCovidBooster: "medCovidBooster",
    medN95Fit: "medN95Fit",

    relFluVax: "relFluVax",
    relCovidVax: "relCovidVax",
    relCovidBooster: "relCovidBooster",
    relN95Fit: "relN95Fit",

}

export const exemptionStatus = {
	non: {shortName:"",longName:"",key:"non"},
	newApplication:{shortName:"Submitted",longName:"New Request",key:"newApplication",statusDesc:"Application submitted"},
	inReview:{shortName:"In Review",longName:"In Review",key:"inReview",statusDesc:"Application in review"},
	pendingLegal:{shortName:"Pending Legal",longName:"Pending Legal",key:"pendingLegal",statusDesc:"Application pending legal"},
	approved:{shortName:"Approved",longName:"Approved",key:"approved",statusDesc:"Application approved"},
	declined:{shortName:"Declined",longName:"Declined",key:"declined",statusDesc:"Application declined"},
	tmpApproved:{shortName:"Temp Approved",longName:"Temporary Approved",key:"tmpApproved",statusDesc:"Application approved"},
	expired:{shortName:"Expired",longName:"Expired",key:"expired",statusDesc:"Application expired"},
	pendingMoreInfo:{shortName:"More Info",longName:"More Information",key:"pendingMoreInfo",statusDesc:"Application pending more info"},
	updatedApplication:{shortName:"Updated",longName:"Updated",key:"updatedApplication",statusDesc:"Application was updated"},
	vaxComplete:{shortName:"Vax Completed",longName:"Vaccine Completed",key:"vaxComplete",statusDesc:"You received vaccination"},
	notRequired:{shortName:"Not Required",longName:"Not Required",key:"notRequired",statusDesc:"Application no longer required"},
	draft:{shortName:"Draft",longName:"Requestor Draft",key:"draft",statusDesc:"Application not submitted"},
	terminated:{shortName:"Terminated",longName:"Terminated user",key:"terminated",statusDesc:"Application cancelled due to termination"}
}

export const settledExemptionStatus = {
	[exemptionStatus.approved.key]:exemptionStatus.approved,
	[exemptionStatus.declined.key]:exemptionStatus.declined,
	[exemptionStatus.tmpApproved.key]:exemptionStatus.tmpApproved,
	[exemptionStatus.vaxComplete.key]:exemptionStatus.vaxComplete,
	[exemptionStatus.notRequired.key]:exemptionStatus.notRequired,
	[exemptionStatus.terminated.key]:exemptionStatus.terminated,
	[exemptionStatus.expired.key]:exemptionStatus.expired
}

export const noActionExemptionStatus = {
	[exemptionStatus.newApplication.key]:exemptionStatus.newApplication,
	[exemptionStatus.inReview.key]:exemptionStatus.inReview,
	[exemptionStatus.updatedApplication.key]:exemptionStatus.updatedApplication,
	[exemptionStatus.approved.key]:exemptionStatus.approved,
	[exemptionStatus.tmpApproved.key]:exemptionStatus.tmpApproved,
	[exemptionStatus.vaxComplete.key]:exemptionStatus.vaxComplete,
	[exemptionStatus.notRequired.key]:exemptionStatus.notRequired,
	[exemptionStatus.terminated.key]:exemptionStatus.terminated
}
